/* eslint-disable ember/classic-decorator-hooks */
import EmberObject from '@ember/object';

import FilterConstants from '../../../../filter-constants';
import * as CommonUtils from '../../../../utils/common';

export default class InductorLowPass extends EmberObject {
  // Inputs
  r1 = null;
  r3 = null;
  r4 = null;
  optimization = null;
  stageFp = null;
  gain = null;
  algorithm = null;

  // Outputs
  iBias = null;
  gbw = null;
  rOut = null;
  specialGain = null;
  name = 'ideal';
  slewRate = 0;
  rOutOverGBW = FilterConstants.Limits.INFINITY;

  init() {
    super.init();

    if (
      CommonUtils.isNullOrUndefined(this.r1) ||
      CommonUtils.isNullOrUndefined(this.r3) ||
      CommonUtils.isNullOrUndefined(this.r4) ||
      CommonUtils.isNullOrUndefined(this.stageFp) ||
      CommonUtils.isNullOrUndefined(this.gain) ||
      CommonUtils.isNullOrUndefined(this.optimization) ||
      CommonUtils.isNullOrUndefined(this.algorithm)
    ) {
      throw 'Required values are incomplete. Please provide r1, r3, r4, stageFp, gain, optimization, and algorithm';
    }

    this.iBias = this.computeIBias();
    this.gbw = this.computeGbw();
    this.rOut = this.computeROut(this.gbw);
    this.specialGain = this.computeSpecialGain();
  }

  computeSpecialGain() {
    return 1 + this.r4 / this.r3;
  }

  computeGbw() {
    var inductorMultiplier = this.optimization.opAmpRequirementSpecValues.inductorMultiplier;
    var result = inductorMultiplier * this.stageFp * this.gain;
    return result;
  }

  computeIBias() {
    var dcOutputVoltageFromIBias = this.optimization.opAmpRequirementSpecValues.dcOutputVoltageFromIBias;
    var iBiasResistance = this.r1;
    return dcOutputVoltageFromIBias / iBiasResistance / this.gain;
  }

  computeROut(gbw) {
    return this.rOutOverGBW * gbw;
  }
}
